import React from 'react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { Space } from 'antd';
import { TwitterIcon, FacebookIcon, LinkedInIcon } from 'components/Icons';

interface Props {
    title: string;
    teaser: string;
    url: string;
}

const ShareButtons = ({ title, teaser, url }: Props): React.JSX.Element => {
    const titleParsed = title.replace(/<[^>]*>?/gm, '');
    const teaserParsed = teaser?.replace(/<[^>]*>?/gm, '');
    return (
        <Space size="middle">
            <TwitterShareButton title={titleParsed} url={url}>
                <TwitterIcon style={{ fontSize: 24 }} />
            </TwitterShareButton>
            <FacebookShareButton title={titleParsed} url={url}>
                <FacebookIcon style={{ fontSize: 24 }} />
            </FacebookShareButton>
            <LinkedinShareButton title={titleParsed} summary={teaserParsed} url={url} source={url}>
                <LinkedInIcon style={{ fontSize: 24 }} />
            </LinkedinShareButton>
        </Space>
    );
};

export default ShareButtons;
